import React from 'react';
export function Footer() {
  return <footer className="bg-[#05070d] py-12 px-5 md:px-8 border-t border-[#1a1f3a]" data-id="element-39">
      <div className="max-w-5xl mx-auto text-center" data-id="element-40">
        <div className="text-white font-serif font-bold text-xl tracking-wide mb-6" data-id="element-41">
          PROTOCOLO SILENCIO 11PM
        </div>

        <div className="flex justify-center gap-6 mb-8" data-id="element-42">
          <a href="#" className="text-gray-500 hover:text-[#d4a853] transition-colors text-sm" data-id="element-43">
            Políticas de Privacidad
          </a>
          <a href="#" className="text-gray-500 hover:text-[#d4a853] transition-colors text-sm" data-id="element-44">
            Términos y Condiciones
          </a>
        </div>

        <div className="text-gray-600 text-xs leading-relaxed max-w-3xl mx-auto space-y-4" data-id="element-45">
          <p data-id="element-46">
            DESCARGO DE RESPONSABILIDAD: Este producto no sustituye el consejo
            médico profesional, diagnóstico o tratamiento. Siempre busque el
            consejo de su médico u otro proveedor de salud calificado con
            cualquier pregunta que pueda tener sobre una condición médica.
          </p>
          <p data-id="element-47">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
          <p data-id="element-48">
            &copy; {new Date().getFullYear()} Protocolo Silencio 11PM. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}